//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  layout: 'noCookie',
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
    }),
  },
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'info-privacyverklaring')
      ])
  },
  head() {
    return {
      title: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.title : 'Privacyverklaring | Info | Secret Circle',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.title : 'Privacyverklaring | Info | Secret Circle' },
        { hid: 'og:title', name: 'og:title', content: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.title : 'Privacyverklaring | Info | Secret Circle', },
        { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/info/privacy' },
        { hid: 'og:description', name: 'og:description', content: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.description : 'Privacy is voor ons altijd in een belangrijk uitgangspunt geweest. We gaan discreet om met de persoonsgegevens die wij ontvangen. Deze verklaring is bedoeld voor transparantie, zodat jij als gebruiker van onze websites kan begrijpen hoe wij met de ontvangen persoonsgegevens omgaan.' },
        { hid: 'description', name: 'description', content: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.description : 'Privacy is voor ons altijd in een belangrijk uitgangspunt geweest. We gaan discreet om met de persoonsgegevens die wij ontvangen. Deze verklaring is bedoeld voor transparantie, zodat jij als gebruiker van onze websites kan begrijpen hoe wij met de ontvangen persoonsgegevens omgaan.' },
        { hid: 'keywords', name: 'keywords', content: this.pages.infoprivacyverklaring ? this.pages.infoprivacyverklaring.seo.keywords : 'Privacy, Privacyverklaring, transparantie'},
        ]
    }
  },
}
